class HamburgerMenu {
  constructor() {
    this.$header = $('.l-header');
    this.$hamburger = $('.l-header__hamburger');
    this.$drawer = $('.l-header__drawer');
    this.$overlay = $('.l-header__drawer-overlay');
    this.$accordion = $('.l-header__drawer-nav-accordion');

    if (this.$hamburger.length > 0) {
      this.event();
    }
  }

  open() {
    this.$header.addClass('is-drawer-open');
    this.$drawer.addClass('is-open').attr('aria-hidden', 'false');
    this.$overlay.addClass('is-open');
    this.$hamburger.attr('aria-expanded', 'true');
    $('html').addClass('is-hidden');
  }

  close() {
    this.$header.removeClass('is-drawer-open');
    this.$drawer.removeClass('is-open').attr('aria-hidden', 'true');
    this.$overlay.removeClass('is-open');
    this.$hamburger.attr('aria-expanded', 'false');
    $('html').removeClass('is-hidden');
  }

  event() {
    this.$hamburger.on('click', () => {
      if (this.$drawer.hasClass('is-open')) {
        this.close();
      } else {
        this.open();
      }
    });

    this.$overlay.on('click', () => this.close());

    this.$accordion.on('click', function () {
      $(this).toggleClass('is-active');
      $(this).next('.l-header__drawer-sub-list').slideToggle(300);
    });
  }
}
